(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('LanguageLocalization', LanguageLocalization);

    LanguageLocalization.$inject = ['$resource', 'DateUtils'];

    function LanguageLocalization ($resource, DateUtils) {
        var resourceUrl =  'api/language-localizations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
